<app-datatable
  [dataSourceUrl]="dtDataSourceUrl"
  [settings]="dtSettings"
  [events]="this.dtEvents"
  (onInit)="onDtInit($event)"
  (onAction)="this.onDtAction($event)"
>
  <th class="column-hide" data-data="id">Id</th>
  <th data-data="fullName">Név</th>
  <th data-data="email">E-mail cím</th>
  <th data-data="idNumber">Okmányszám</th>
  <th class="column-actions">Műveletek</th>
</app-datatable>
